import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function ProductShowcase() {
  const tomos = [{
    icon: '📘',
    title: 'TOMO 1 — ENTENDIENDO EL TDAH',
    desc: '50 módulos. Qué es, cómo funciona el cerebro, los 3 tipos, el diagnóstico correcto, las emociones del padre y los primeros pasos concretos. El punto de partida que todo padre necesita.'
  }, {
    icon: '📗',
    title: 'TOMO 2 — DOMESTICANDO EL CAOS',
    desc: 'Rutinas visuales, estructura del hogar, organización por bloques horarios. Mañana, tarde y noche resueltas. Plan de implementación de 30 días incluido.'
  }, {
    icon: '📙',
    title: 'TOMO 3 — LA CONEXIÓN EMOCIONAL',
    desc: 'Regulación emocional, validación, vínculo seguro, crianza consciente, autoestima y reparación del lazo. Para cuando el amor no alcanza y necesitás herramientas.'
  }, {
    icon: '📕',
    title: 'TOMO 4 — ALIADOS EN LA ESCUELA',
    desc: 'Cómo comunicarte con maestros y directivos. Estrategias de inclusión, adaptaciones curriculares y derechos educativos. Trabajá con la escuela, no contra ella.'
  }, {
    icon: '📓',
    title: 'TOMO 5 — EL MUNDO SOCIAL',
    desc: 'Amistades, recreo, cumpleaños y situaciones grupales. Habilidades sociales adaptadas al cerebro TDAH. Para que tu hijo no se sienta solo en el mundo.'
  }, {
    icon: '📔',
    title: 'TOMO 6 — EL LARGO PLAZO',
    desc: 'Adolescencia, identidad, vocación y vida adulta con TDAH. Construí el futuro desde hoy con una visión clara. Porque el TDAH no termina en la infancia.'
  }];
  const features = ['Contenido 100% listo — abrís el PDF y empezás', 'Guiones exactos para situaciones reales', 'Tablas, checklists y herramientas visuales', 'Actividades prácticas para hacer con tu hijo', 'Diseñado para el padre hispanohablante real'];
  return <section className="py-24 px-4 bg-slate-950" data-id="element-286">
      <div className="max-w-6xl mx-auto" data-id="element-287">
        <div className="text-center mb-16" data-id="element-288">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-amber-500 text-slate-900 font-black px-6 py-2 rounded-full mb-6 text-sm md:text-base tracking-widest uppercase" data-id="element-289">
            🏆 NUEVO NIVEL — COMBO COMPLETO TDAH
          </motion.div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-290">
            6 Tomos + 6 Bonos — Del Diagnóstico al Futuro
          </h2>
          <p className="text-2xl text-amber-400 font-bold mb-4" data-id="element-291">
            300+ páginas — Todo resuelto.
          </p>
          <p className="text-slate-400 font-medium tracking-wide" data-id="element-292">
            Diagnóstico · Rutinas · Emociones · Escuela · Social · Futuro
          </p>
        </div>

        <div className="mb-16" data-id="element-293">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-294">
            <span className="text-amber-400" data-id="element-295">💛</span> 6 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-296">
            {tomos.map((tomo, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-900 border border-slate-800 rounded-2xl p-6 hover:border-amber-500/50 transition-all hover:-translate-y-1" data-id="element-297">
                <div className="text-4xl mb-4" data-id="element-298">{tomo.icon}</div>
                <h4 className="text-lg font-bold text-white mb-3 leading-tight" data-id="element-299">
                  {tomo.title}
                </h4>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-300">
                  {tomo.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-900/50 border border-amber-500/20 rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-301">
          <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-302">
            ✅ CADA TOMO INCLUYE:
          </h4>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-303">
            {features.map((feat, i) => <div key={i} className="flex items-start gap-3" data-id="element-304">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-305" />
                <span className="text-slate-300 font-medium" data-id="element-306">{feat}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}